import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import { Trans, useTranslation } from "react-i18next";

import AlertDialog from "../../components/AlertDialog";
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import howToFindUsername from "../../images/how-to-find-username.png";
import styles from "./FirstTimeLoginModal.module.scss";

export default function FirstTimeLoginModal({ open, onClose }) {
  const { t } = useTranslation();

  const highlight = { hl: <span className={styles.highlight} /> };

  return (
    <AlertDialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      title={
        <div className={styles.title}>
          <div className={styles.logo}>
            <FlashCoachLogo />
          </div>
          <h6 className={styles.heading}>{t("login.firstTimeTitle")}</h6>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label={t("login.firstTimeClose")}
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
      }
      body={
        <div className={styles.body}>
          <p className="mb-3 text-secondary">{t("login.firstTimeIntro")}</p>

          <div className={styles.credentials}>
            <div className={styles.credRow}>
              <span className={styles.badge} aria-hidden="true">
                U
              </span>
              <span>
                <strong>{t("login.firstTimeUsernameLabel")}</strong>{" "}
                <Trans i18nKey="login.firstTimeUsername" components={highlight} />
              </span>
            </div>
            <div className={styles.credRow}>
              <span className={styles.badge} aria-hidden="true">
                P
              </span>
              <span>
                <strong>{t("login.firstTimePasswordLabel")}</strong>{" "}
                <Trans i18nKey="login.firstTimePassword" components={highlight} />
              </span>
            </div>
          </div>

          <img
            src={howToFindUsername}
            alt={t("login.firstTimeImageAlt")}
            className={styles.screenshot}
          />

          <div className={styles.caption}>
            <Trans i18nKey="login.firstTimeCaption" components={highlight} />
          </div>

          <div className={styles.note}>
            <strong>{t("login.firstTimeNoteLabel")}</strong>{" "}
            {t("login.firstTimeNote")}
          </div>
        </div>
      }
      footer={
        <button type="button" className={styles.gotItBtn} onClick={onClose}>
          {t("login.firstTimeGotIt")}
        </button>
      }
    />
  );
}

FirstTimeLoginModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
